/* eslint-disable */
import { produce } from "immer";
import {
  I_WANT_TO_COMBO_FETCH_FAILURE,
  I_WANT_TO_COMBO_FETCH_START,
  I_WANT_TO_COMBO_FETCH_SUCCESS,
} from "../actions/types";

const iWantToCombo = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case I_WANT_TO_COMBO_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case I_WANT_TO_COMBO_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case I_WANT_TO_COMBO_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default iWantToCombo;
